let productName = "简历"

export default productName
